export default __webpack_public_path__ + "static/media/heart-2.a3830bec.svg";